import {
   GET_MERCHANT_TOP_USED_TERMINAL_FAILED , GET_MERCHANT_TOP_USED_TERMINAL_SUCCESS , GET_MERCHANT_CURRENT_PREVIOUS_MONTH_SALES_LOADING , REMOVE_MERCHANT_TOP_USED_TERMINAL, GET_MERCHANT_TOP_USED_TERMINAL_LOADING
} from "../types";

const initialState = {
    topUsedTerminal: null,
    loading: null,
    error: null,
};

export const getTopUsedTerminalReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_MERCHANT_TOP_USED_TERMINAL_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_MERCHANT_TOP_USED_TERMINAL_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                topUsedTerminal: action.payload,
            };
        case GET_MERCHANT_TOP_USED_TERMINAL_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case REMOVE_MERCHANT_TOP_USED_TERMINAL:
            return initialState;

        default:
            return state;
    }
};
